import React, { useContext } from 'react'
import { ContentHeader } from '../../layout/Content'
import { receiptItemControllerContext } from './ReceiptItemController'
import ReceiptItemHeaderStyle from './css/ReceiptItemHeaderStyle'

function ReceiptItemHeader() {
  const receiptItemController = useContext(receiptItemControllerContext)
  const { receipt } = receiptItemController
  const [receiptToView, setReceiptToView] = receiptItemController.receiptToView
  return (
    <ContentHeader>
      <div id='receipts-header-container'>
        <div id='receipt-header-label'>Official Receipt</div>
          {
            (receipt.receipt_for.item_name === 'Invoice') &&
            <div id='receipts-tab'>
              <button
                onClick={() => setReceiptToView('OR')}
                className={(receiptToView === 'OR') ? 'pospro-action-btn tab active-tab' : 'pospro-action-btn tab'}>
                Offical Receipt
              </button>

              {/*Express Mode Sales Invoice*/}
              <button
                onClick={() => setReceiptToView('EMSI')}
                className={(receiptToView === 'EMSI') ? 'pospro-action-btn tab active-tab' : 'pospro-action-btn tab'}>
                Invoice/Receipt
              </button>
            </div>
          }
      </div>
      <ReceiptItemHeaderStyle />
    </ContentHeader>
  )
}

export default React.memo(ReceiptItemHeader)
